import(/* webpackMode: "eager", webpackExports: ["Empty"] */ "__barrel_optimize__?names=Empty!=!/opt/fa-build/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "__barrel_optimize__?names=Tabs!=!/opt/fa-build/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/opt/fa-build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/common/image/CommonImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/pages/home/instructorDetails/tabContent/CourseInfo.js");
